// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TvzA","option":"styles_option__2dm8p","selected":"styles_selected__2jeUZ"};